import Highlighter from '@/Utils/Admin/HighLighter';

const highlightFieldPrefix = 'focusFields';
const offsetElements = ['.js-navigation-bar', '.js-screen-bar'];

export default {
    methods: {
        initializeHighlighter() {

            if (this.$route.query && this.$route.query[highlightFieldPrefix]) {
                const focusFields = this.$route.query.focusFields.split(',');
                const defaultOffset = Highlighter.getDefaultOffset(offsetElements);

                focusFields.forEach((item, index) => {
                    const fieldName = `model.${ item }`;
                    const elementList = document.getElementsByName(fieldName) || [];
                    const isFirstItem = index === 0;

                    elementList.forEach(el => {
                        Highlighter.highlightParentOf(el, true, isFirstItem, defaultOffset);
                    });
                });

            }
        },
    },
};
